import React from 'react';
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import ReactMarkdown from 'react-markdown';
import OnVisible from 'react-on-visible';
import breaks from 'remark-breaks';
import { containers, Grid } from 'style';

const ContactBarComponent = ({ firstAddress, secondAddress, links }) => (
    <OnVisible percent={20}>
        <Grid.InnerContainer id="ContactsBar" className="markdown">
            <Grid.Row>
                <Col>
                    <RowWrapper>
                        <FooterContactFirstAddress>
                            <ReactMarkdown
                                source={firstAddress}
                                plugins={[breaks]}
                                renderers={{ root: 'div', paragraph: 'span' }}
                            />
                        </FooterContactFirstAddress>
                        <FooterContactSecondAddress>
                            <ReactMarkdown
                                source={secondAddress}
                                plugins={[breaks]}
                                renderers={{ root: 'div', paragraph: 'span' }}
                            />
                        </FooterContactSecondAddress>
                        <FooterContactLinks>
                            {links &&
                                links.map(link => (
                                    <div key={link.id}>
                                        <a href={link.url} target="_blank">
                                            {link.title}
                                        </a>
                                    </div>
                                ))}
                        </FooterContactLinks>
                    </RowWrapper>
                </Col>
            </Grid.Row>
        </Grid.InnerContainer>
    </OnVisible>
);
const Col = styled(Grid.Col)`
    display: flex;
    flex-wrap: wrap;
`;
const RowWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    @media (min-width: 750px) {
        flex-wrap: nowrap;
    }
`;

const FooterContactInfo = css`
    white-space: nowrap;
    a {
        text-decoration: none;
        color: inherit;
    }
    transition: all 0s;
    transform: translateY(40px);
    opacity: 0.01;

    .visible & {
        transition: all 0.5s;
        transform: translateY(0px);
        opacity: 1;
    }
    @media (min-width: ${containers.innerPX}px) {
        padding: 0;
        & + & {
            margin-left: 120px;
        }
    }
`;

const FooterContactFirstAddress = styled.div`
    ${FooterContactInfo};
    order: 0;
`;
const FooterContactSecondAddress = styled.div`
    ${FooterContactInfo};
    order: 3;
    width: 100%;
    margin-top: ${containers.padding}px;
    @media (min-width: 750px) {
        order: 1;
        width: auto;
        margin-top: 0;
        margin-left: 120px;
    }
`;
const FooterContactLinks = styled.div`
    ${FooterContactInfo};
    order: 4;
    margin-top: ${containers.padding}px;
    @media (min-width: 375px) {
        order: 1;
        width: auto;
        margin-top: 0;
        margin-left: auto;
    }
`;

export default ContactBarComponent;
